// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"bd5a1381","323":"b8959c03","453":"54292a4b"}[chunkId] + ".chunk.js";
};